module.exports = __webpack_public_path__ + "static/media/zip.473eac09.svg";